export default {"src":"/_next/static/media/lexoya-wordmark.fb488145.svg","height":555,"width":1887,"blurWidth":0,"blurHeight":0};